export { Heading } from './Heading';
export type { HeadingLevelType } from './Heading';
